import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { useDispatch, useSelector } from 'react-redux';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl, toBool } from '../../../utils/Helper';
import CustomDropDown from '../../../components/customDropdown/customDropdown';
import { formatLocalTime } from '../../../js/utility';
import { setRenderFlashMessage } from '../../../Redux/Actions/appConfigAction';
import CustomPressable from '../../../components/customPressable/customPressable';
import CustomDrawer from '../../../components/customDrawer';

const ReservationAvailability = (props) => {
    const { preferredVenueDetails, sePreferredVenueDetails, venueAvailability, dailyProgrammeData, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice?.extraConfigParam) || false;
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;
    

    const [selectedTimeData, setSelectedTimeData] = useState({
        "shiftCategory": "",
        "reservationTime": "",
        "dailyProgramAck": false,
        "availableTime": ""
    })
    


    const handleItemSelect = (shiftCategory, availableTime) => {
        setSelectedTimeData({ ...selectedTimeData, shiftCategory: shiftCategory.shift_category, reservationTime: availableTime?.value?.time_iso.split(" ")[1], availableTime: availableTime?.value })
    }

    const handleGoNext = () => {
        if(selectedTimeData.reservationTime == ""){
            dispatch(setRenderFlashMessage(true, { type: "danger", message: t('reservations.select_preferred_time_slot') }))
            return;
        }
        sePreferredVenueDetails((prev) => ({
            ...prev,
            shiftCategory: selectedTimeData.shiftCategory,
            reservationTime: selectedTimeData.reservationTime,
            availableTime: selectedTimeData.availableTime
        }))
        handleNext(selectedTimeData)
    }

    const updateDataFromProps = () => {
        setSelectedTimeData({ ...selectedTimeData, shiftCategory: preferredVenueDetails.shiftCategory || "", reservationTime: preferredVenueDetails.reservationTime || "", availableTime: preferredVenueDetails.availableTime })
    }

    useEffect(() => {
        updateDataFromProps();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsAvailabilityHeaderContainer'])} id='sevenRoomsAvailabilityHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsAvailabilityHeaderImg'])} id={"sevenRoomsAvailabilityHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsAvailabilityMainPageHeaderTitleContainer'])} id='sevenRoomsAvailabilityMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsAvailabilityHeaderTitle'])} id='sevenRoomsAvailabilityHeaderTitle'>{t('reservations.heading2a')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'sevenRoomsAvailabilityHeaderSubTitle'])} id='sevenRoomsAvailabilityHeaderSubTitle'>{t('reservations.sub_heading2b')}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsAvailabilityRootContainer'])} id="widgetRootContainer sevenRoomsAvailabilityRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsAvailabilityMainContainer'])} 
                showsVerticalScrollIndicator={false}
                nestedScrollEnabled
                id='sevenRoomsAvailabilityMainContainer'
            >
                {renderHeader()}
                
                <View style={getStyles(['widgetmainContainerChildContainer', 'sevenRoomsAvailabilityMainContainerChildContainer'])} id='sevenRoomsAvailabilityMainContainerChildContainer'>
                    {
                        venueAvailability?.length && venueAvailability.map((shiftCategory, shiftIndex) => {
                            const isDailyProgrammeRunning = dailyProgrammeData?.find((dailyProgramme) => 
                                dailyProgramme.shift_categories_display && 
                                dailyProgramme.shift_categories_display.toLowerCase() == shiftCategory.shift_category.toLowerCase()
                            )

                            return (
                                <View key={shiftIndex} style={getStyles(["textContainer"])}>
                                    <CustomDrawer 
                                        label={
                                            isDailyProgrammeRunning ? (
                                                <>
                                                {shiftCategory.name}{' '}
                                                <Text style={getStyles(["sevenRoomsEventsHappeningText"])} id='sevenRoomsEventsHappeningText'>
                                                    ({t('reservations.dailyProgramAck.event_happening')})
                                                </Text>
                                                </>
                                            ) : (
                                                shiftCategory.name
                                            )
                                        }
                                        placeholder={""}
                                        options={shiftCategory?.times?.map((availableTime) => {
                                            return {
                                                label: formatLocalTime(new Date(availableTime.time_iso), toBool(TIME_FORMAT)),
                                                value: availableTime
                                            }
                                        })}
                                        selectedOption={selectedTimeData.shiftCategory == shiftCategory.shift_category ? selectedTimeData.availableTime : ""}
                                        onSelectOption={(availableTime) => {
                                            handleItemSelect(shiftCategory, availableTime)
                                        }}
                                    />
                                </View>
                            )})
                    }
                    
                </View>
                
            </ScrollView>
            <View style={getStyles(['sevenRoomsReservationDetails_button_container'])} id='sevenRoomsReservationDetails_button_container'>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleGoNext} id='primaryBtn'>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('reservations.next')}</Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack} id='secondaryBtn'>
                    <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('reservations.back')}</Text>
                </CustomPressable> */}
            </View>


        </View>
    )
}

export default ReservationAvailability
